import { CustomerParams } from "@/model/CustomerParams";
import store from "@/store";
export class CustomerService {
  getPutParams(param: any): CustomerParams {
    const id = store.getters["ReservationDetail/uketsukeExtendsId"];
    const uketsukeCd = store.getters["ReservationDetail/uketsukeCd"];
    const yoyakuNo = store.getters["ReservationDetail/yoyakuNo"];
    return {
      id,
      uketsukeCd,
      yoyakuNo,
      ...param
    };
  }
}
